import { LOCATION_CHANGE } from 'connected-react-router';

import featureFlags from 'config/featureFlags';

/**
 * State container reducer for feature flags.
 * @param {object}   state   state container
 * @param {string}   type
 * @param {*}        payload
 * @returns {object}
 */
export default function featureFlagReducer(state = {}, { type, payload }) {
  switch (type) {
    case LOCATION_CHANGE: {
      const { location: { search } } = payload;

      return Object.values(featureFlags).reduce(
        (activeFlags, featureFlag) => {
          if (search.includes(`${featureFlag}=true`)) {
            // eslint-disable-next-line no-param-reassign -- Reassigning in this reducer is ok as we created a new object to start with
            activeFlags[featureFlag] = true;
          }
          return activeFlags;
        }, {});
    }

    default:
      return state;
  }
}
